<template>
	<simple-modal
		:display="showModal"
		:title="title"
		@close="closeModal"
		class="is-overlay"
	>
		<div class="chatbot">
			<p class="is-4 title">{{ this.$props.translations.import.upload.intro }}</p>
			<p class="is-5 is-dangerous">{{ this.$props.translations.import.upload.warning }}</p>

			<form
				class="is-padded-top is-padded-bottom"
				@submit.prevent="uploadFile"
			>
				<div class="field">
					<div class="control label-around-input">
						<label class="label">
							{{ this.$props.translations.import.upload.field }}
						</label>
						<input
							type="file"
							@change="uploadChanged"
						/>
					</div>
				</div>
				<div class="buttons">
					<button
						type="submit"
						class="button control is-fullwidth is-primary"
						:disabled="file.uploadButton.disabled"
						:class="{'is-loading': file.uploadButton.loading}"
					>
						{{ this.$props.translations.import.upload.submit }}
					</button>
				</div>
			</form>
			<div v-if="file.fileId" :class="{'is-loading': file.stats.loading}" class="columns is-centered">
				<ul class="column">
					<li class="is-size-5 is-padded-top" v-for="(value, key) in file.stats.data">
						<span class="has-text-weight-semibold">{{ translations.stats [ key ] }}</span> : {{ value }}
					</li>
				</ul>
			</div>
			<div v-if="file.fileId && !file.stats.loading" class="columns is-centered is-padded-top">
				<button class="button is-marged-right is-marged-top" :class="{'is-loading': buttons.cancel.loading}" @click="cancel">{{ this.$props.translations.buttons.cancel }}</button>
				<button class="button is-marged-left is-marged-top" :class="{'is-loading': buttons.confirm.loading}" @click="submit">{{ this.$props.translations.buttons.confirm }}</button>
			</div>

		</div>
	</simple-modal>
</template>

<script>
export default {
	name: "import-file",
	data: function()
	{
		return {
			file: {
				fileId: null,
				uploadedFile: null,
				uploadButton: {
					loading: false,
					disabled: true,
				},
				stats: {
					loading: false,
					data: null,
				},
			},
			interval: null,
			buttons: {
				confirm: {
					loading: false,
				},
				cancel: {
					loading: false,
				},
			},
		}
	},
	props: {
		showModal : {
			type: Boolean,
			required: true,
		},
		title: {
			type: String,
			required: false,
		},
		translations: {
			type: Object,
			required: true,
		},
		urls: {
			type: Object,
			required: true,
		}
	},
	methods: {
		closeModal()
		{
			this.cancel();
		},
		uploadChanged(event)
		{
			if (event.target.files)
			{
				this.file.uploadedFile = event.target.files;
				this.file.uploadButton.disabled = false;
			}
			else
			{
				this.file.uploadedFile = null;
				this.file.uploadButton.disabled = true;
			}
		},
		uploadFile()
		{
			this.file.uploadButton.disabled = true;

			let formData = new FormData();
			formData.append('file', this.file.uploadedFile[0]);

			new ApiMonizze(new LoaderState(this.file.uploadButton))
				.postDataFromApi(
					this.urls.upload,
					formData,
					(data) =>
					{
						this.file.fileId = data.fileId;
						this.launchInterval();
					}
				)
		},
		launchInterval()
		{
			if (this.file.fileId)
			{
				var loaderState = new LoaderState(this.file.stats);
				loaderState.setLoadingState(true);

				this.loadStats();
				this.interval = setInterval(this.loadStats, 5000);
			}
		},
		loadStats()
		{
			var apiStats = new ApiMonizze();

			apiStats.getDataFromApi(
				this.urls.stats.replace('{file}', this.file.fileId),
				(data) => {
					this.file.stats.data = data.stats;
					if (data.done === true)
					{
						clearInterval(this.interval);
						this.file.stats.loading = false;
					}
				}
			);
		},
		submit()
		{
			new ApiMonizze(new LoaderState(this.buttons.confirm))
				.postDataFromApi(
					this.urls.confirm.replace('{file}', this.file.fileId),
					{},
					() => {
						this.$emit('done');
					}
				);
		},
		cancel()
		{
			this.$emit('close');
		}
	},
}
</script>
